import * as Sentry from '@sentry/react'
import {
  QueryCache,
  QueryClient,
  QueryClientConfig,
} from '@tanstack/react-query'

import { HttpError } from '@/services/fintalk/api/types/errors/HttpError'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'

import { setSentryEventId } from './utils/sentry-events-id'
import { shouldReportError } from './utils/should-report-error'

const defaultOptions: QueryClientConfig['defaultOptions'] = {
  queries: {
    staleTime: 60_000, // 1 minute
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (failureCount >= 2) return false

      if (error instanceof NetworkError) return true

      if (error instanceof HttpError) {
        const statusCode = error.response?.statusCode

        return statusCode ? statusCode >= 500 : false
      }

      return false
    },
  },
}

const queryCache = new QueryCache({
  onError: (error) => {
    if (!shouldReportError(error)) return

    const eventId = Sentry.captureException(error)

    setSentryEventId(error, eventId)
  },
})

export const queryClient = new QueryClient({
  defaultOptions,
  queryCache,
})
